// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1132":"3ecfc7cf","4315":"3ecfc7cf","8337":"3ecfc7cf","9085":"3ecfc7cf"}[chunkId] + ".chunk.css";
};